/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Broker information linked to a payment schedule
 * @export
 * @interface PaymentScheduleBrokerDto
 */
export interface PaymentScheduleBrokerDto {
    /**
     * Unique identifier of the broker
     * @type {string}
     * @memberof PaymentScheduleBrokerDto
     */
    id: string;
    /**
     * Company name of the broker
     * @type {string}
     * @memberof PaymentScheduleBrokerDto
     */
    companyName?: string | null;
    /**
     * Email address of the broker
     * @type {string}
     * @memberof PaymentScheduleBrokerDto
     */
    email?: string | null;
    /**
     * Phone number of the broker
     * @type {string}
     * @memberof PaymentScheduleBrokerDto
     */
    phone?: string | null;
}

/**
 * Check if a given object implements the PaymentScheduleBrokerDto interface.
 */
export function instanceOfPaymentScheduleBrokerDto(value: object): value is PaymentScheduleBrokerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PaymentScheduleBrokerDtoFromJSON(json: any): PaymentScheduleBrokerDto {
    return PaymentScheduleBrokerDtoFromJSONTyped(json, false);
}

export function PaymentScheduleBrokerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentScheduleBrokerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function PaymentScheduleBrokerDtoToJSON(json: any): PaymentScheduleBrokerDto {
    return PaymentScheduleBrokerDtoToJSONTyped(json, false);
}

export function PaymentScheduleBrokerDtoToJSONTyped(value?: PaymentScheduleBrokerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'email': value['email'],
        'phone': value['phone'],
    };
}

